import slugify from "@sindresorhus/slugify";

export const getAnalyticsId = (...strings: Array<string>) => {
	return strings.map((s) => slugify(s, { separator: "_" })).join("_");
};

export { slugify };

// 🔬 TBD: Please evaluate
